import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React from "react";
import { classNames } from "../utils/formatters";

interface AccordionProps {
  title: string;
  Component: JSX.Element;
  accordionOpen: boolean;
  containerClassName?: string;
  buttonClassName?: string;
  iconClassName?: string;
  setAccordionOpen: (state: boolean) => void;
}

const Accordion = ({
  title,
  Component,
  accordionOpen,
  setAccordionOpen,
  containerClassName,
  buttonClassName,
  iconClassName,
}: AccordionProps) => {
  return (
    <div
      className={classNames(
        `rounded-md my-5 overflow-visible w-full`,
        containerClassName
      )}
    >
      <button
        type="button"
        onClick={() => setAccordionOpen(!accordionOpen)}
        className={classNames(
          `flex py-4 overflow-visible justify-between w-full items-center transition-all duration-300 border-b border-gray-200 pb-5`,
          buttonClassName
        )}
      >
        <span className="font-medium ">{title}</span>
        <ChevronDownIcon
          className={classNames(
            "mr-2 ml-2 h-8 w-8 text-orange-500 hover:text-orange-400 transform origin-center transition duration-200 ease-out",
            accordionOpen && "!rotate-180",
            iconClassName
          )}
          aria-hidden="true"
        />
      </button>
      <div
        className={`w-full ${
          accordionOpen ? "pt-4" : ""
        } overflow-visible transition-all duration-300 ease-in-out text-slate-600 text-sm`}
      >
        {accordionOpen ? Component : null}
      </div>
    </div>
  );
};

export default Accordion;
